// Tier 2: Zod parse de TODA resposta de /api/refunds.
// Schemas de request vivem em @control-center/shared (compartilhado com API).

import {
  createRefundResponseSchema,
  listRefundsResponseSchema,
  type CreateRefundRequest,
  type ListRefundsResponse,
  type RefundItem,
} from '@control-center/shared';

import { apiClient } from './api-client';

export async function createRefund(payload: CreateRefundRequest): Promise<RefundItem> {
  const res = await apiClient.post<unknown>('/api/refunds', payload);
  const parsed = createRefundResponseSchema.parse(res.data);
  return parsed.data;
}

export async function fetchRefundsByCharge(chargeId: string): Promise<ListRefundsResponse> {
  const res = await apiClient.get<unknown>(`/api/refunds?chargeId=${chargeId}`);
  return listRefundsResponseSchema.parse(res.data);
}
